import { MessageNotice } from './message-notice';

export class MessageNoticeBatchSet {

  // 消息通知属性
  messageNotice: MessageNotice[];
  // sendMessage时做判断
  isBatchCopy: boolean;
  // 目标节点ID
  targetNodeID: string[];
}
